/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1669593600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Mon Nov 28 2022 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "front",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Setup",
          "depth": 0,
          "id": "setup"
        }, {
          "value": "Modes",
          "depth": 0,
          "id": "modes"
        }, {
          "value": "Upsert contacts",
          "depth": 1,
          "id": "upsert-contacts"
        }, {
          "value": "Update contacts",
          "depth": 1,
          "id": "update-contacts"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      h3: "h3",
      strong: "strong",
      a: "a",
      img: "img"
    }, _provideComponents(), props.components), {NoCommonErrors, LiveDebugger, SyncAlerts} = _components;
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "setup",
        children: "Setup"
      }), "\n", _jsx(_components.p, {
        children: "To get an API Token, in the Front app, navigate to Settings > Plugins & API > API and click the New Token button."
      }), "\n", _jsx(_components.h2, {
        id: "modes",
        children: "Modes"
      }), "\n", _jsx(_components.h3, {
        id: "upsert-contacts",
        children: "Upsert contacts"
      }), "\n", _jsx(_components.p, {
        children: "In this mode, new contacts will be inserted into Front and existing contacts will be updated."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: "User Identification"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["To determine whether a contact should be created or updated, you will need to provide a column mapping that can be associated with a unique ", _jsx(_components.a, {
          href: "https://dev.frontapp.com/reference/contacts",
          children: "Handle"
        }), " in Front."]
      }), "\n", _jsx(_components.p, {
        children: "A user can have multiple handles but we will only use one to determine the existence of a contact in Front. Please provide this mapping in this section of the sync configuration:"
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-front-field-mappings.png",
          alt: ""
        })
      }), "\n", _jsx(Warning, {
        children: _jsx(_components.p, {
          children: "Please ensure that the column you are mapping to is unique and non-null. Also\nkeep in mind that making changes to this mapping later on can result in\nunexpected behavior."
        })
      }), "\n", _jsx(_components.h3, {
        id: "update-contacts",
        children: "Update contacts"
      }), "\n", _jsx(_components.p, {
        children: "In this mode, existing contacts will be updated in Front but new contacts will not be inserted."
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(NoCommonErrors, {}), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
